module.exports = __webpack_public_path__ + "static/ebonie-67f01567c05b5f66ba7980fe7c682ed1.jpg";